import React from "react";
import Section from "../../Section";
import AppointmentSection from "../../Section/AppointmentSection";
import SectionHeading from "../../SectionHeading";
import Spacing from "../../Spacing";
import { pageTitle } from "../../../helpers/PageTitle";

const ClearAlignerTreatmentPlanning = () => {
  pageTitle("Free Clear Aligner Case Evaluation");
  return (
    <>
      <Section className="cs_footer_margin_0">
        <div
          className="cs_banner cs_style_4 cs_bg_filed overflow-hidden text-center"
          style={{
            backgroundImage: `url(/images/about/banner_bg_2.jpg)`,
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '20px',
            position: 'relative'
          }}
        >
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.4)',
            zIndex: 1
          }}></div>
          <div style={{ zIndex: 2, padding: '40px' }}>
            <h2 className="cs_banner_title cs_white_color cs_fs_72">
              Free Clear Aligner <br />Case Evaluation
            </h2>
            <p className="cs_banner_subtitle cs_white_color cs_fs_20 m-0 mt-4">
              Get an expert evaluation of your case within 24-48 hours.
            </p>
          </div>
        </div>
      </Section>

      <Section topMd={100} topLg={80} topXl={60}>
        <div className="container">
          <SectionHeading title="Our Workflow" titleUp="HOW IT WORKS" center={true} />
          <Spacing md="40" lg="30" />
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <ol className="cs_fs_20 cs_heading_color" style={{ lineHeight: '1.8' }}>
                <li className="mb-3">Evaluating all records and treatment plan mailed to us.</li>
                <li className="mb-3">Within 24 hours the dedicated Orthodontist will index your case as simple, moderate or complex.</li>
                <li className="mb-3">Within 48 hours the plan will be sent to your email address.</li>
                <li className="mb-3">Once the case has been approved by the dentist, stl files for printing will be mailed.</li>
              </ol>
            </div>
          </div>
        </div>
      </Section>

      <Section topMd={100} topLg={80} topXl={60}>
        <div className="container">
          <SectionHeading title="Records Required" titleUp="WHAT WE NEED" center={true} />
          <Spacing md="40" lg="30" />
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row">
                <div className="col-md-6 mb-4">
                  <h4 className="cs_fs_24 cs_semibold mb-3 cs_heading_color">Photographs: Intra oral 5 views</h4>
                  <ul className="cs_fs_18 cs_heading_color" style={{ listStyleType: 'none', paddingLeft: 0, lineHeight: '1.8' }}>
                    <li>1. Frontal</li>
                    <li>2. Right lateral</li>
                    <li>3. Left lateral</li>
                    <li>4. Upper occlusal</li>
                    <li>5. Lower occlusal</li>
                  </ul>
                </div>
                <div className="col-md-6 mb-4">
                  <h4 className="cs_fs_24 cs_semibold mb-3 cs_heading_color">Extra oral 6 views</h4>
                  <ul className="cs_fs_18 cs_heading_color" style={{ listStyleType: 'none', paddingLeft: 0, lineHeight: '1.8' }}>
                    <li>1. Frontal</li>
                    <li>2. Frontal smile</li>
                    <li>3. Oblique</li>
                    <li>4. Oblique smile</li>
                    <li>5. Lateral</li>
                    <li>6. Lateral smile</li>
                  </ul>
                </div>
                <div className="col-md-12">
                  <h4 className="cs_fs_24 cs_semibold mb-3 cs_heading_color">Radiographs & Others</h4>
                  <ul className="cs_fs_18 cs_heading_color" style={{ listStyleType: 'disc', paddingLeft: '20px', lineHeight: '1.8' }}>
                    <li className="mb-2">Lateral cepahlogram, OPG, CBCT (if required)</li>
                    <li className="mb-2">.stl files evaluation</li>
                    <li className="mb-2">Treatment form filled by the doctor</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Section>

      <Section
        topMd={100}
        topLg={80}
        topXl={60}
        bottomMd={190}
        bottomLg={145}
        bottomXl={110}
        id="appointment"
      >
        <AppointmentSection
          sectionTitle="Appointment"
          sectionTitleUp="BOOK AN"
          imgUrl="/images/home_1/appointment.jpeg"
        />
      </Section>
    </>
  );
};

export default ClearAlignerTreatmentPlanning;